var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64117 9.02237L0.90228 12.2113C0.87679 12.3278 0.877664 12.4486 0.904837 12.5648C0.93201 12.681 0.984795 12.7897 1.05934 12.8828C1.13388 12.976 1.2283 13.0514 1.33569 13.1034C1.44308 13.1554 1.56073 13.1828 1.68006 13.1835C1.73566 13.1891 1.79168 13.1891 1.84728 13.1835L5.05561 12.4446L11.2156 6.30793L7.77784 2.87793L1.64117 9.02237Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1523 3.23582L10.8579 0.941371C10.707 0.791285 10.5029 0.707031 10.2901 0.707031C10.0773 0.707031 9.87318 0.791285 9.72233 0.941371L8.44678 2.21693L11.8807 5.65082L13.1562 4.37526C13.2309 4.30023 13.29 4.21123 13.3302 4.11333C13.3704 4.01543 13.3909 3.91056 13.3906 3.80473C13.3902 3.6989 13.369 3.59417 13.3281 3.49655C13.2872 3.39893 13.2275 3.31033 13.1523 3.23582Z",
    fill: "#B0B7C3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.e70b7c4b94d41b69f9d99c28a50ab751.svg";
export { ForwardRef as ReactComponent };